export const async_llm_urls = {
  asyncType: 'async_urls_llm',
  hostedScraperType: 'async_urls_llm',
  publicHostedScraperAPIType: 'async_urls_llm',
  inputKey: 'url',
  inputsKey: 'urls',
  inputJsonSchema: {type: 'string'},
  propertiesJsonSchemaPart: {
    device_type: { type: 'string', 'enum': [ 'desktop', 'mobile'] },
    follow_redirect: { type: 'boolean' },
    premium: { type: 'boolean' },
    render: { type: 'boolean' },
    screenshot: { type: 'boolean' },
    retry_404: { type: 'boolean' },
    ultra_premium: { type: 'boolean' },
    wait_for_selector: { type: 'string' },
    output_format: { type: 'string', enum: [ 'markdown', 'text' ] },
    tld: { type: 'string' },
    country_code: { type: 'string' }
  }
};